const HOME = "home";

export { HOME };
